// Acabou o tempo
import apaulinhacarlos01 from './audios/apaulinhacarlos.01.mp4';
import apaulinhacarlos02 from './audios/apaulinhacarlos.02.mp4';
import cybersekh from './audios/cybersekh.mp3';
import ernanicavila from './audios/ernanicavila.ogg';
import isaacost from './audios/isaacost.ogg';
import lelesakae01 from './audios/lelesakae.01.mp3';
import lelesakae02 from './audios/lelesakae.02.mp3';
import lelesakae03 from './audios/lelesakae.03.mp3';
import LucasHenriqueAbreu from './audios/LucasHenriqueAbreu.02.mp4';
import maitemarques from './audios/maite-marques.mp3';
import nataliakoliveira from './audios/nataliakoliveira.ogg';
import ThiagoFdaSLopes from './audios/ThiagoFdaSLopes.02.mp3';
import WeydsonCristiano from './audios/WeydsonCristiano.ogg';
import wgamaneto from './audios/wgamaneto.ogg';

const fimdotempo = [
  lelesakae01,
  lelesakae02, 
  lelesakae03, 
  ernanicavila, 
  isaacost, 
  wgamaneto, 
  WeydsonCristiano, 
  maitemarques, 
  ThiagoFdaSLopes, 
  cybersekh, 
  nataliakoliveira, 
  apaulinhacarlos01, 
  apaulinhacarlos02,
  LucasHenriqueAbreu
];

export default fimdotempo;